import CustomPermissionModalComponent from './custom-permission-modal-component'
import CustomPermissionModalService from './custom-permission-modal-service'

/***
 * The modal that pops up on the User Admin page, allowing you to select the custom permissions to use for a User
 * whose access doesn't fall into one of the existing roles.
 */
const customPermissionModal = angular
    .module('FacilityData.UserAdmin.CustomPermission', [])
    .component('customPermissionModal', CustomPermissionModalComponent)
    .service('CustomPermissionModalService', CustomPermissionModalService)
    .name;

export default customPermissionModal;


// WEBPACK FOOTER //
// ./app/components/user-admin/custom-permission-modal/custom-permission-modal.js